import React from 'react'
import styles from './TopBar.module.scss'
import { APP_VERSION, USE_DEV_API } from '../config'
import { STAMP } from '../builddate'

function AppVersion({ user }) {
	return (
		<div className={styles.menuItemVersion}>
			{user ? (
				<>
					<span>v{APP_VERSION}</span>
					{USE_DEV_API && <span style={{ fontSize: '11px' }}>{STAMP}</span>}
				</>
			) : (
				<span>v{APP_VERSION}</span>
			)}
		</div>
	)
}

export default React.memo(AppVersion)
